module.exports = __webpack_public_path__ + "static/media/frontpage.c39bed36.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/practice/frontpage.png
// module id = 116
// module chunks = 0